var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ClozeInput from './ClozeInput';
import styles from './styles.less';

var Cloze = function (_Component) {
  _inherits(Cloze, _Component);

  function Cloze() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Cloze);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cloze.__proto__ || Object.getPrototypeOf(Cloze)).call.apply(_ref, [this].concat(args))), _this), _this.clozeInputClick = function (id) {
      var setInputId = _this.context.setInputId;

      setInputId(id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Cloze, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var addToClozeAnswers = this.context.addToClozeAnswers;

      addToClozeAnswers();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.context.getClozeAnswers.length) {
        this.$clozeWrapper.scrollTop = 0;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var text = this.props.text;
      var _context = this.context,
          getClozeAnswers = _context.getClozeAnswers,
          getInputId = _context.getInputId;

      var clozeText = text.replace(/(<(.|\n)*?>|&nbsp;)/g, '').split(/{{?([^}]*)}}/g).map(function (part, index) {
        var key = index + '-inputkey';
        if (part.match(/^c.\d*/g)) {
          var inputText = getClozeAnswers ? getClozeAnswers.find(function (answer) {
            return answer.id.includes(part);
          }) : null;
          return React.createElement(ClozeInput, { key: key, id: part, text: inputText ? inputText.text : '', onClick: _this2.clozeInputClick, hasFocus: getInputId === part });
        }
        return part;
      });
      return React.createElement(
        'div',
        {
          ref: function ref(clozeWrapper) {
            _this2.$clozeWrapper = clozeWrapper;
          },
          className: styles.clozeWrapper
        },
        React.createElement(
          'div',
          { className: styles.text },
          clozeText
        )
      );
    }
  }]);

  return Cloze;
}(Component);

Cloze.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired
} : {};

Cloze.contextTypes = {
  addToClozeAnswers: PropTypes.func,
  getClozeAnswers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string
  })),
  setAnswer: PropTypes.func,
  setInputId: PropTypes.func,
  getInputId: PropTypes.string
};

export default Cloze;